import { render, staticRenderFns } from "./FinancialCard.vue?vue&type=template&id=06541ac8&scoped=true"
import script from "./FinancialCard.vue?vue&type=script&lang=js"
export * from "./FinancialCard.vue?vue&type=script&lang=js"
import style0 from "./FinancialCard.vue?vue&type=style&index=0&id=06541ac8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06541ac8",
  null
  
)

export default component.exports